// @flow
import type { StatelessFunctionalComponent } from 'react';
import styled from 'styled-components';

const SendEmailWrapper: StatelessFunctionalComponent<*> = styled.div`
  position: relative;

  .SendEmail {
    &-container {
      display: grid;
      text-align: center;
    }

    &-container-image {
      margin: 0 auto;
      padding: 40px 10px 10px;
    }

    &-image {
      width: 100%;
    }

    &-text {
      max-width: 460px;
      margin: 0 auto;
      font-size: 18px;
      padding: 20px;
      line-height: 1.5;
      text-align: center;
      color: var(--text-color-2);
    }

    &-button-container {
      cursor: pointer;
      text-align: center;
      margin: 0 auto;
      max-width: 400px;
      color: var(--white-color);
    }
  }

`;

export default SendEmailWrapper;
